import { Component, forwardRef } from "react";
import Loader from "../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Pagination from "../../utils/pagination";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from "../../actions/fillCombo_action";
import AdminDrawer from "../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../common_components/header_with_logo";
import "react-datepicker/dist/react-datepicker.css";
import ExhibitorHeader from "../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../common_components/exhibitor_module_topmenu";
import ConfirmationModal from "../../common_components/confirmationa_modal";
import {
  getHallManagerWorkUpdatationList_action,
  updateHallManagerWorkUpdatationList_action,
  getWorkUpdationLogList_action,
  getVendorStaffList_action,
} from "../../actions/admin_module_action/hall_manager_action/work_updation_action";
import { formatServerDateTime } from "../../utils/vendor_datetime_helper";
import {
  exhibitionId,
  hallActionId,
  HallZoneActionId,
  serviceTypeId,
  stallActionId,
  toastError,
  toastSuccess,
  isOtherAreaActionId
} from "../../utils/constants";
import Select from "react-select";
import Modal from "react-modal";
import moment from "moment";
import FasciaForm from "../exhibitor_module/manual_forms/forms/fascia_Form/fascia_form";
import ExhibitorBadge from "../exhibitor_module/manual_forms/forms/exhibitor_badge_form/exhibitor_badge";
import ExhibitorDetails from "../exhibitor_module/manual_forms/forms/exhibitor_details_form/exhibitor_details";
import VisaApplication from "../exhibitor_module/manual_forms/forms/invitationVisaApplication/invitationVisaApplicationList";
import EDirectoryList from "../exhibitor_module/manual_forms/forms/e-direcory_form/e-directory_list";
import KeywordsInformation from "../exhibitor_module/manual_forms/forms/keywords_information_form/keywords_information";
import StallDesign from "../exhibitor_module/manual_forms/forms/stallDesign/stallDesign";
import AdditionalFurniture from "../exhibitor_module/manual_forms/forms/additional furniture/additional_furniture";
import StallPossession from "../exhibitor_module/manual_forms/forms/stall_possesion/stall_possesion";
import PowerConnection from "../exhibitor_module/manual_forms/forms/power_connection_form/power_connection";
import FreightForward from "../exhibitor_module/manual_forms/forms/freight_forward/freight_forward";
import Water from "../exhibitor_module/manual_forms/forms/water_form/water";
import AirConnectionApplication from "../exhibitor_module/manual_forms/forms/airConnectionApplication/airConnectionApplication";
import CarPassesApplication from "../exhibitor_module/manual_forms/forms/car_passes_application/car_passes_application";
import LiquareLicense from "../exhibitor_module/manual_forms/forms/liquare_license/liquare_license";
import LeadRetrievalConnectionApplication from "../exhibitor_module/manual_forms/forms/leadRetrievalConnectionApplication/leadRetrievalConnectionApplication";
import MeetingRoomRequestForm from "../exhibitor_module/manual_forms/forms/Meeting room request form/MeetingRoomRequestForm";
import DelegateMeeting from "../exhibitor_module/manual_forms/forms/delegate_meeting/delegate_meeting";
import VisitorMeetingApplication from "../exhibitor_module/manual_forms/forms/visitor_meeting_application/visitor_meeting_application";
import InternetConnection from "../exhibitor_module/manual_forms/forms/internet_connection/internet_connection";
import HousekeepingConnection from "../exhibitor_module/manual_forms/forms/housekeeping_connection/housekeeping_connection";
import SecurityApplication from "../exhibitor_module/manual_forms/forms/security_application/security_application";
import CateringServices from "../exhibitor_module/manual_forms/forms/catering_services/catering_services";
import HostHostessRequirements from "../exhibitor_module/manual_forms/forms/host_hostess_requirement/host_hostess_requirement";
import BrandingOpportunityAndAdvertisement from "../exhibitor_module/manual_forms/forms/brandingApportunityAndAdvertisement/brandingApportunityAndAdvertisement";
import RentalAudioAndVideoEquipment from "../exhibitor_module/manual_forms/forms/rentalAudioAndVedioEquipment/rentalAudioAndVedioEquipment";
import ExhibitorContractorBadgeApplication from "../exhibitor_module/manual_forms/forms/exhibitor_contractor_badgeApplication/exhibitor_contractor_badgeApplication";
import PlantAndBeautification from "../exhibitor_module/manual_forms/forms/PlantAndBeautification/PlantAndBeautification";
import RentalAudioAndVedioEquipment from "../exhibitor_module/manual_forms/forms/rentalAudioAndVedioEquipment/rentalAudioAndVedioEquipment";

// import 'bootstrap-icons/font/bootstrap-icons.css';

const styles = {
  width: "100%",
};

class WorkUpdation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmationObj: { message: '', buttonName: '', action: '' },
      popArg: [],
      isOpenConfirmationModal: false,
      isLoading: false,
      HMworkUpdationList: [],
      AccountID: "",
      StatusID: "",
      isUpdateModalOpen: false,
      hallId: "",
      hallList: [],
      zoneId: "",
      zoneList: [],
      serviceId: "",
      serviceList: [],
      ExhRegNo: "",
      ExhibitorName: "",
      VendorName: "",
      OtherAreaCountList: [],
      ExhibitionOtherAreaID: "",
      PossessionStatusID: "",
      HMworkUpdationListForFilter: [],
      ListIndex: null,
      StatusList: [],
      HallManagerList: [],
      isHallManagerModalOpen: false,
      RoleID: sessionStorage.getItem("RoleIDSS"),
      isCommentPop: false,
      commentList: [],
      isOtherAreaList: [],
      isManualFormModalOpen: false,
      selectedServiceName: null,
      showVideoModal: false,
      // Which of the Total / Completed / Pending count filters is applied to the grid,
      // kept in state so a background refresh can re-apply it
      countFilter: "pending",
      isHallManager: JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 16,
      isTeamMember: JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 20,
      isAdmin:
        JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 6 ||
        JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 2,
      // The Zone Manager verifies first: their tick locks the row for the Service
      // Partner, and the Hall Manager's locks it for them in turn
      isZoneManager:
        JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 25,
    };

    this.getHallManagerWorkUpdationList = this.getHallManagerWorkUpdationList.bind(this);
    this.renderWorkUpdationList = this.renderWorkUpdationList.bind(this);

    this.handleConfirmation = this.handleConfirmation.bind(this)
    this.pollingTimer = null;
  }


  isFlagOn = (value) => value === 1 || value === true;

  // Role 20 can update work status only. The approval workflow is restricted to
  // roles 25 and 16; all other roles keep every control editable.
  isRestrictedWorkflowRole = () =>
    this.state.isZoneManager ||
    this.state.isHallManager ||
    this.state.isTeamMember;

  canSetZoneApproval = (
    isWorkCompleted,
    isHallApproved,
    isOrganizerApproved
  ) => {
    if (!this.isRestrictedWorkflowRole()) return true;

    return (
      (this.state.isZoneManager || this.state.isHallManager) &&
      isWorkCompleted &&
      !isHallApproved &&
      !isOrganizerApproved
    );
  };

  canSetHallApproval = (isZoneApproved, isOrganizerApproved) => {
    if (!this.isRestrictedWorkflowRole()) return true;

    return (
      this.state.isHallManager &&
      isZoneApproved &&
      !isOrganizerApproved
    );
  };

  zoneLockedMessage = (isOrganizerApproved) =>
    isOrganizerApproved
      ? "Verified by Organizer - this row is frozen"
      : "Verified by Hall Manager - the zone tick can no longer be changed";

  lockedMessage = (isOrganizerApproved) =>
    isOrganizerApproved
      ? "Verified by Organizer - this row is frozen"
      : "Verified by Hall Manager - this row can no longer be changed";

  toggleTaskZoneApproval = (HMWorkupdationID, currentValue) => {
    const { HMworkUpdationList } = this.state;
    const current = HMworkUpdationList.find(
      (item) => item.HMWorkupdationID === HMWorkupdationID
    );
    if (!current) return;
    if (
      !this.canSetZoneApproval(
        this.isFlagOn(current.WorkStatusID),
        this.isFlagOn(current.IsVerifyByHallManager),
        this.isFlagOn(current.IsVerifyByOrganizer)
      )
    ) {
      if (this.state.isZoneManager || this.state.isHallManager) {
        toastError(
          !this.isFlagOn(current.WorkStatusID)
            ? "Work status must be marked Complete before Zone Manager verification."
            : this.zoneLockedMessage(this.isFlagOn(current.IsVerifyByOrganizer))
        );
      }
      return;
    }
    const newValue = !this.isFlagOn(currentValue) ? 1 : 0;
    const updatedList = HMworkUpdationList.map((item) =>
      item.HMWorkupdationID === HMWorkupdationID
        ? { ...item, IsVerifyByZoneManager: newValue }
        : item
    );
    this.setState({ HMworkUpdationList: updatedList }, () =>
      // 6 is the Zone Manager tier on both notification stores
      this.updateApproval(HMWorkupdationID, "IsVerifyByZoneManager", newValue, 6)
    );
  };

  toggleTaskHallApproval = (HMWorkupdationID, currentValue) => {
    const { HMworkUpdationList } = this.state;
    const current = HMworkUpdationList.find(
      (item) => item.HMWorkupdationID === HMWorkupdationID
    );
    if (!current) return;
    if (
      !this.canSetHallApproval(
        this.isFlagOn(current.IsVerifyByZoneManager),
        this.isFlagOn(current.IsVerifyByOrganizer)
      )
    ) {
      if (this.state.isHallManager) {
        toastError(
          !this.isFlagOn(current.IsVerifyByZoneManager)
            ? "Zone Manager verification is required before Hall Manager verification."
            : this.lockedMessage(true)
        );
      }
      return;
    }
    const newValue = !this.isFlagOn(currentValue) ? 1 : 0;
    const updatedList = HMworkUpdationList.map((item) =>
      item.HMWorkupdationID === HMWorkupdationID
        ? {
          ...item,
          IsVerifyByHallManager: newValue,
          /* The Hall Manager verification is the final one: the procedure
             writes the Organizer column and its stamp as a copy of this. Shown
             here at once so the two cells never disagree while the save is in
             flight - the refresh that follows reads back what was stored */
          IsVerifyByOrganizer: newValue,
        }
        : item
    );
    this.setState({ HMworkUpdationList: updatedList }, () =>
      this.updateApproval(HMWorkupdationID, "IsVerifyByHallManager", newValue, 2)
    );
  };

  toggleTaskApproval = (HMWorkupdationID, currentValue) => {
    if (!this.state.isAdmin) return;
    const { HMworkUpdationList } = this.state;
    const newValue = !this.isFlagOn(currentValue) ? 1 : 0;
    const updatedList = HMworkUpdationList.map((item) =>
      item.HMWorkupdationID === HMWorkupdationID
        ? { ...item, IsVerifyByOrganizer: newValue }
        : item
    );
    this.setState({ HMworkUpdationList: updatedList }, () =>
      this.updateApproval(HMWorkupdationID, "IsVerifyByOrganizer", newValue, 3)
    );
  };

  updateApproval(HMWorkupdationID, field, value, notifyEventTypeID) {
    // Optimistic update already applied - revert on failure
    const snapshot = this.state.HMworkUpdationList.map((r) => ({ ...r }));
    const row = this.state.HMworkUpdationList.find((r) => r.HMWorkupdationID === HMWorkupdationID);
    if (!row) return;
    const array = [{
      HMWorkupdationID,
      [field]: value,
      HallID: row.HallID || null,
      ZoneID: row.ZoneID || null,
      StallID: row.StallId || null,
      ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
      ExhRegistrationID: row.ExhRegistrationID || null,
      ServiceID: row.ServiceID || null,
      VendorID: row.VendorAccountID || null,
      ScheduledDate: row.ScheduledDate != null ? moment(row.ScheduledDate).format("YYYY-MM-DD") : null,
      WorkStatusID: row.WorkStatusID,
      Remark: row.Remark || null,
      IsCompletedTag: row.IsCompletedTag || false,
      IsRemarkAdd: row.IsRemarkAdd || false,
      IsVerifyByHallManager: row.IsVerifyByHallManager || false,
      IsVerifyByOrganizer: row.IsVerifyByOrganizer || false,
      IsVerifyByZoneManager: row.IsVerifyByZoneManager || false,
    }];
    this.setState({ isLoading: true });
    this.props
      .updateHallManagerWorkUpdatationList_action(array, undefined, {
        EventTypeID: notifyEventTypeID || null,
        IsPositive: value ? 1 : 0,
      })
      .then((data) => {
        if (data.error != 1) {
          toastSuccess("Verification updated successfully!");
          this.getHallManagerWorkUpdationList(true);
        } else {
          toastError(data.msg);
          this.setState({ HMworkUpdationList: snapshot });
        }
        this.setState({ isLoading: false });
      })
      .catch((err) => {
        console.error("Error in updateApproval:", err);
        toastError("Something went wrong!");
        this.setState({ HMworkUpdationList: snapshot, isLoading: false });
      });
  }

  handleConfirmation(flag) {
    const { confirmationObj, popArg } = this.state;
    if (flag) {
      if (confirmationObj.action == 0) {
        this.updateHallManagerWorkUpdation()
      }
    }
    this.setState({ isOpenConfirmationModal: false })
  }

  async componentDidMount() {
    await this.getFillList(hallActionId, this.state.exhibitionID, "", "", "", "");
    await this.getFillList(serviceTypeId, this.state.exhibitionID, "", "", "", "");
    await this.getHallManagerWorkUpdationList();
    console.log("this.props", this.props);
    this.startPolling();
  }

  componentWillUnmount() {
    this.stopPolling();
  }

  // Refresh the grid every 15s in the background (no page reload, no loader flicker)
  startPolling() {
    this.stopPolling();
    this.pollingTimer = setInterval(() => {
      // The update modal edits HMworkUpdationList in place before it is saved, so refreshing
      // while any modal is open would throw away the user's unsaved work
      const {
        isUpdateModalOpen,
        isHallManagerModalOpen,
        isCommentPop,
        isManualFormModalOpen,
        isOpenConfirmationModal,
        showVideoModal,
      } = this.state;
      if (
        isUpdateModalOpen ||
        isHallManagerModalOpen ||
        isCommentPop ||
        isManualFormModalOpen ||
        isOpenConfirmationModal ||
        showVideoModal ||
        document.hidden
      ) {
        return;
      }
      this.getHallManagerWorkUpdationList(true);
    }, 15000);
  }

  stopPolling() {
    if (this.pollingTimer) {
      clearInterval(this.pollingTimer);
      this.pollingTimer = null;
    }
  }

  // Sorts the rows of each break section separately so break headers keep their own rows
  applySort(list, field, order) {
    const sortData = (data) => {
      return [...data].sort((a, b) => {
        const aVal = a[field];
        const bVal = b[field];

        if (aVal == null && bVal == null) return 0;
        if (aVal == null) return 1;
        if (bVal == null) return -1;

        const aStr = aVal.toString().toLowerCase();
        const bStr = bVal.toString().toLowerCase();

        if (aStr < bStr) return order === "asc" ? -1 : 1;
        if (aStr > bStr) return order === "asc" ? 1 : -1;
        return 0;
      });
    };

    const sortedList = [];
    let currentGroup = [];
    let currentBreak = null;

    list.forEach((item) => {
      if (item.isBreak) {
        // Push previous section (before or under previous break)
        if (currentGroup.length > 0) {
          if (currentBreak) {
            sortedList.push(currentBreak, ...sortData(currentGroup));
          } else {
            // Data before first break
            sortedList.push(...sortData(currentGroup));
          }
          currentGroup = [];
        }
        currentBreak = item;
      } else {
        currentGroup.push(item);
      }
    });

    // Handle last group or items after last break
    if (currentGroup.length > 0) {
      if (currentBreak) {
        sortedList.push(currentBreak, ...sortData(currentGroup));
      } else {
        sortedList.push(...sortData(currentGroup));
      }
    }

    return sortedList;
  }

  handleSort = (field) => {
    const { sortField, sortOrder, HMworkUpdationList } = this.state;
    const newSortOrder = sortField === field && sortOrder === "asc" ? "desc" : "asc";

    this.setState({
      HMworkUpdationList: this.applySort(HMworkUpdationList, field, newSortOrder),
      sortField: field,
      sortOrder: newSortOrder,
    });
  };

  async getFillList(actionID, exhibitionID, moduleID, keyValue, value, from, flag, isSilent = false) {
    if (!isSilent) this.setState({ isLoading: true });

    try {
      const data = await this.props.fill_action(actionID, exhibitionID, moduleID, keyValue, value);

      if (data && data.error !== 1) {
        if (actionID === hallActionId) {
          this.setState({ hallList: data.data });
        } else if (actionID === HallZoneActionId) {
          this.setState({ zoneList: data.data });
        } else if (actionID === serviceTypeId) {
          this.setState({ serviceList: data.data });
        } else if (actionID === isOtherAreaActionId) {
          this.setState({ isOtherAreaList: data.data });
        }

        return data.data; // ✅ ALWAYS return here
      }

      return null; // ✅ explicit return when error === 1
    } catch (e) {
      console.log(e);
      return null; // ✅ explicit return on error
    } finally {
      if (!isSilent) this.setState({ isLoading: false });
    }
  }

  // isSilent = background poll: keep the loader hidden and don't toast transient errors
  async getHallManagerWorkUpdationList(isSilent = false) {
    const {
      AccountID,
      zoneId,
      ExhibitorName,
      VendorName,
      StatusID,
      hallId,
      ExhRegNo,
      ExhibitionOtherAreaID,
      PossessionStatusID,
      serviceId,
    } = this.state;

    if (!isSilent) this.setState({ isLoading: true });
    const data = await this.getFillList(
      isOtherAreaActionId,
      this.state.exhibitionID,
      "",
      "",
      "",
      "",
      undefined,
      isSilent
    );

    const breaksList = (data || []).map((item) => ({
      key: item.Name,
      label: item.Name,
    }));

    try {
      const data = await this.props.getHallManagerWorkUpdatationList_action(
        AccountID,
        zoneId,
        ExhibitorName,
        VendorName,
        StatusID,
        hallId,
        ExhRegNo,
        ExhibitionOtherAreaID,
        PossessionStatusID,
        serviceId
      );

      // Handle API error
      if (data.error === 1) {
        if (!isSilent) toastError(data.msg);
        return;
      }

      // Extract main list safely
      let list = Array.isArray(data.data?.[0]) ? [...data.data[0]] : [];
      const otherAreaList = Array.isArray(data.data?.[1]) ? data.data[1] : [];
      const StatusList = Array.isArray(data.data?.[2]) ? data.data[2] : [];
      const hallManagerList = Array.isArray(data.data?.[3]) ? data.data[3] : [];

      // Remove old breaks
      list = list.filter((item) => !item.isBreak);

      list = list.map((row) => ({
        ...row,
        isBreakRow: false,
      }));

      const breakBlocks = [];

      breaksList.forEach(({ key, label }) => {
        const keyLower = key.toLowerCase();

        // rows that belong to this break
        const rows = list.filter((item) => item.Hall?.toLowerCase() === keyLower);
        if (rows.length > 0) {
          // 2) Add break header
          breakBlocks.push({
            Hall: label,
            Zone: label,
            isBreak: true,
            isBreakRow: true,
          });

          // 3) Add each matched row as break row
          rows.forEach((row) => {
            breakBlocks.push({
              ...row,
              isBreakRow: true,
            });
          });

          // 4) Remove matched rows from the normal list
          list = list.filter((item) => item.Hall?.toLowerCase() !== keyLower);
        }
      });

      // 5) Append break rows at end
      list.push(...breakBlocks);

      if (!isSilent) console.log("list----->", list);

      // Keep whichever count filter and column sort the user has applied to the grid,
      // so a background refresh doesn't reset their view
      const { countFilter, sortField, sortOrder } = this.state;
      let visibleList = this.applyCountFilter(list, countFilter);
      if (sortField) {
        visibleList = this.applySort(visibleList, sortField, sortOrder);
      }

      this.setState({
        HMworkUpdationList: visibleList,
        OtherAreaCountList: otherAreaList,
        HMworkUpdationListForFilter: list,
        StatusList: StatusList,
      });
    } catch (err) {
      console.error("Error in getHallManagerWorkUpdationList:", err);
      if (!isSilent) {
        toastError("Something went wrong while fetching Hall Manager Work Updation list.");
      }
    } finally {
      if (!isSilent) this.setState({ isLoading: false });
    }
  }

  applyCountFilter(list, countFilter) {
    if (countFilter === "completed") {
      return list.filter((item) => item.WorkStatusID == 1 && !item.isBreak);
    }
    if (countFilter === "pending") {
      return list.filter((item) => item.WorkStatusID != 1 && !item.isBreak);
    }
    return list;
  }

  async getWorkUpdationLogList(HMWorkupdationID) {
    if (HMWorkupdationID) {
      this.setState({ isLoading: true });
      try {
        const data = await this.props.getWorkUpdationLogList_action(HMWorkupdationID);
        if (data.error === 1) {
          toastError(data.msg);
          return;
        }
        this.setState({ commentList: data.data[0].filter(item => item.Remark), isCommentPop: true });
      } catch (err) {
        console.error("Error in getWorkUpdationLogList:", err);
        toastError("Something went wrong!");
      } finally {
        this.setState({ isLoading: false });
      }
    } else {
      this.setState({ commentList: [], isCommentPop: true });
    }
  }

  async getVendorStaffList(VendorID, ServiceID) {
    if (VendorID && ServiceID) {
      this.setState({ isLoading: true });
      try {
        const data = await this.props.getVendorStaffList_action(VendorID, ServiceID);
        if (data.error === 1) {
          toastError(data.msg);
          return;
        }
        this.setState({
          HallManagerList: this.groupStaffByService(data.data[0]),
          isHallManagerModalOpen: true,
        });
      } catch (err) {
        console.error("Error in getVendorStaffList:", err);
        toastError("Something went wrong!");
      } finally {
        this.setState({ isLoading: false });
      }
    } else {
      this.setState({ HallManagerList: [], isHallManagerModalOpen: true });
    }
  }

  updateHallManagerWorkUpdation() {
    const { HMworkUpdationList } = this.state;
    const array = [];
    console.log("HMworkUpdationList----->", HMworkUpdationList);
    HMworkUpdationList.forEach((item) => {
      if (item.ActionID == 1) {
        array.push({
          HMWorkupdationID: item.HMWorkupdationID || null,
          HallID: item.HallID || null,
          ZoneID: item.ZoneID || null,
          StallID: item.StallId || null,
          ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
          ExhRegistrationID: item.ExhRegistrationID || null,
          ServiceID: item.ServiceID || null,
          VendorID: item.VendorAccountID || null,
          ScheduledDate:
            item.ScheduledDate != null ? moment(item.ScheduledDate).format("YYYY-MM-DD") : null,
          WorkStatusID: item.WorkStatusID,
          Remark: item.Remark || null,
          IsCompletedTag: item.IsCompletedTag || false,
          IsRemarkAdd: item.IsRemarkAdd || false,
        });
      }
    });
    if (array.length == 0) {
      return toastError("Please take action on the record!");
    }
    this.setState({ isLoading: true });
    this.props
      .updateHallManagerWorkUpdatationList_action(array)
      .then((data) => {
        if (data.error != 1) {
          toastSuccess("Record updated successfully!");

          this.setState({ isLoading: false, isUpdateModalOpen: false, ExhRegNo: "" }, () => {
            this.getHallManagerWorkUpdationList();
          });
        } else {
          toastError(data.msg);
          this.setState({ isLoading: false });
        }
      })
      .catch((err) => {
        console.error("Error in updateHallManagerWorkUpdation:", err);
        toastError("Something went wrong!");
        this.setState({ isLoading: false });
      });
  }

  handleClear() {
    this.setState(
      {
        AccountID: "",
        StatusID: "",
        hallId: "",
        zoneId: "",
        serviceId: "",
        ExhRegNo: "",
        ExhibitorName: "",
        VendorName: "",
        ExhibitionOtherAreaID: "",
        PossessionStatusID: "",
        ListIndex: null,
        countFilter: "all",
      },
      () => this.getHallManagerWorkUpdationList()
    );
  }

  navigateToVendorAndScopofwork(userId, accountId, WorkOrderID) {
    this.props.navigate("/vendorAndScopofwork", {
      state: {
        AccountID: accountId,
        UserId: userId,
        update: true,
        update: true,
        isView: false,
        replicate: false,
        WorkOrderID: WorkOrderID,
        isHallManager: sessionStorage.getItem("RoleIDSS") == 16,
        isWorkUpdation: true,
      },
    });
  }

  handleInput(e, value, index) {
    // Work Status is maintained by Team Member (RoleID 20) or unrestricted
    // roles. Zone Manager and Hall Manager can verify, but cannot change it.
    if (
      value === "checkbox" &&
      (this.state.isZoneManager || this.state.isHallManager)
    ) {
      return;
    }

    this.setState((prevState) => {
      const updatedList = prevState.HMworkUpdationList.map((item, i) => {
        if (i === index) {
          let updatedItem = { ...item, ActionID: 1 };

          if (value === "checkbox") {
            updatedItem.WorkStatusID = e.target.checked ? 1 : 0; // use numeric if needed
            updatedItem.IsCompletedTag = e.target.checked ? 1 : 0;

          } else {
            updatedItem.Remark = e.target.value;
            updatedItem.IsRemarkAdd = true;
          }

          return updatedItem;
        }

        return item;
      });
      return { HMworkUpdationList: updatedList };
    });
  }

  groupStaffByService(data) {
    // Group by ServiceName first
    const serviceGroups = data.reduce((acc, curr) => {
      const key = curr.ServiceName;
      if (!acc[key])
        acc[key] = {
          WorkOrderID: curr.WorkOrderID,
          ServiceName: curr.ServiceName,
          StaffList: [],
        };
      acc[key].StaffList.push(curr);
      return acc;
    }, {});

    // For each service, merge people across types
    const result = Object.values(serviceGroups).map((service) => {
      const personGroups = service.StaffList.reduce((acc, curr) => {
        const key = `${curr.PersonName}|${curr.EmailID}|${curr.MobileNumber}`;
        if (!acc[key])
          acc[key] = {
            PersonName: curr.PersonName,
            EmailID: curr.EmailID,
            MobileNumber: curr.MobileNumber,
            Types: new Set(),
          };
        acc[key].Types.add(curr.Type);
        return acc;
      }, {});

      const finalPeople = Object.values(personGroups).map((p) => {
        const types = Array.from(p.Types);
        const TypeName = types.length === 3 ? "All" : types.join(" / ");
        return { ...p, TypeName };
      });

      return {
        WorkOrderID: service.WorkOrderID,
        ServiceName: service.ServiceName,
        Staff: finalPeople,
      };
    });

    return result;
  }

  // Single source of truth for the Action column - the column header and the row icons are both
  // built from this list, so adding an action here is enough to get it into the header as well
  getRowActions() {
    return [
      {
        label: "Update Work Status",
        iconClass: "bi bi-pencil grid-icon",
        isVisible: (item) => !item.isBreak,
        onClick: (item) =>
          this.setState(
            {
              isUpdateModalOpen: true,
              ExhRegNo: item.ExhRegistrationNo != 'NA' ? item.ExhRegistrationNo : null,
              ExhibitionOtherAreaID:
                item.ExhRegistrationNo === 'NA'
                  ? this.state.isOtherAreaList.find(
                    obj => obj.Name?.toLowerCase() === item.Hall?.toLowerCase()
                  )?.ExhibitionOtherAreaID || null
                  : null
            },
            () => this.getHallManagerWorkUpdationList()
          ),
      },
    ];
  }

  buildActionHeader(actions, rows) {
    const labels = actions
      .filter((action) => rows.some((item) => item && action.isVisible(item)))
      .map((action) => action.label);
    return labels.length > 0 ? labels.join("/") : "Action";
  }




  renderWorkUpdationList(isModal) {
    const { RoleID, ListIndex, isZoneManager, isHallManager } = this.state;

    // Rows actually rendered by the grid - the Action header is built from these
    const visibleRows =
      ListIndex != null
        ? [this.state.HMworkUpdationList?.[ListIndex]]
        : this.state.HMworkUpdationList || [];
    const rowActions = this.getRowActions();
    const actionHeader = this.buildActionHeader(rowActions, visibleRows);

    const getApprovalDisplay = (
      isApproved,
      onToggle,
      canEdit,
      title = "",
      approvedOn = null
    ) => (
      <div title={title} className="text-center">
        <div className="d-flex align-items-center justify-content-center">
          <div
            className="rounded-circle d-inline-flex align-items-center justify-content-center me-2 border"
            style={{
              width: "10px",
              height: "10px",
              cursor: canEdit ? "pointer" : "not-allowed",
              marginRight: "8px",
              backgroundColor: isApproved ? "#3dbca7" : "",
              borderColor: "#3dbca7",
              opacity: canEdit ? 1 : 0.5,
            }}
            onClick={canEdit ? onToggle : undefined}
          >
            {isApproved && (
              <i
                className="fa fa-check text-white"
                style={{ fontSize: "12px" }}
              ></i>
            )}
          </div>
          <span className="d-flex align-items-center">
            <span
              className="badge rounded-circle me-2"
              style={{ width: "12px", height: "12px", backgroundColor: "#3dbca7" }}
            ></span>
            <span style={{ color: "#3dbca7" }}>
              {isApproved ? "Verified" : "Not Verified"}
            </span>
          </span>
        </div>
        {isApproved && approvedOn && (
          <div
            style={{
              fontSize: "11px",
              color: "#6b7280",
              whiteSpace: "nowrap",
            }}
          >
            {/* Not formatDateTime. These two are real datetime columns, so the
                    driver hands them over tagged as UTC and new Date() would add the
                    offset a second time - 7:30 PM IST printing as 1:00 AM. Same
                    reading the remark and attachment timestamps go through */}
            {formatServerDateTime(approvedOn)}
          </div>
        )}
      </div>
    );

    return (
      <div
        class="table-responsive sticky-table-wrapper border-bottom service-list-grid-1 w-100 p-0">
        <table class="table sticky-table text-nowrap table-bordered border-bottom border-2 mb-0">
          <thead className="table-light" style={{ position: "sticky", top: 0, zIndex: 20, backgroundColor: "#f8f9fa", outline: "1px solid #ddd", outlineOffset: "-1px" }}>
            <tr>
              {/* Hall */}
              <th className="text-center">
                <div className="th-header-with-sort">
                  <span>Hall</span>
                  <div className="icons-shorting" onClick={() => this.handleSort("Hall")}>
                    <i className="fa fa-long-arrow-up" style={{ cursor: "pointer" }}></i>
                    <i
                      className="fa fa-long-arrow-down"
                      style={{ cursor: "pointer", marginLeft: 3 }}
                    ></i>
                  </div>
                </div>
              </th>

              {/* Zone */}
              <th>
                <div className="th-header-with-sort">
                  <span>Zone</span>
                  <div className="icons-shorting" onClick={() => this.handleSort("Zone")}>
                    <i className="" style={{ cursor: "pointer" }}></i>
                    <i
                      className="fa fa-long-arrow-down"
                      style={{ cursor: "pointer", marginLeft: 3 }}
                    ></i>
                  </div>
                </div>
              </th>

              {/* Stall */}
              <th>
                <div className="th-header-with-sort">
                  <span>Stall</span>
                  <div className="icons-shorting" onClick={() => this.handleSort("Stall")}>
                    <i className="fa fa-long-arrow-up" style={{ cursor: "pointer" }}></i>
                    <i
                      className="fa fa-long-arrow-down"
                      style={{ cursor: "pointer", marginLeft: 3 }}
                    ></i>
                  </div>
                </div>
              </th>

              {/* Exhibitor */}
              <th>
                <div className="th-header-with-sort">
                  <span>Exhibitor</span>
                  <div className="icons-shorting" onClick={() => this.handleSort("Exhibitor")}>
                    <i className="fa fa-long-arrow-up" style={{ cursor: "pointer" }}></i>
                    <i
                      className="fa fa-long-arrow-down"
                      style={{ cursor: "pointer", marginLeft: 3 }}
                    ></i>
                  </div>
                </div>
              </th>

              {/* Service */}
              <th>
                <div className="th-header-with-sort">
                  <span>Service</span>
                  <div className="icons-shorting" onClick={() => this.handleSort("Service")}>
                    <i className="fa fa-long-arrow-up" style={{ cursor: "pointer" }}></i>
                    <i
                      className="fa fa-long-arrow-down"
                      style={{ cursor: "pointer", marginLeft: 3 }}
                    ></i>
                  </div>
                </div>
              </th>

              {/* Service Partner */}
              <th>
                <div className="th-header-with-sort">
                  <span>Service Partner</span>
                  <div className="icons-shorting" onClick={() => this.handleSort("VendorName")}>
                    <i className="fa fa-long-arrow-up" style={{ cursor: "pointer" }}></i>
                    <i
                      className="fa fa-long-arrow-down"
                      style={{ cursor: "pointer", marginLeft: 3 }}
                    ></i>
                  </div>
                </div>
              </th>

              {/* Schedule Date */}
              <th>
                <div className="th-header-with-sort">
                  <span>Schedule Date</span>
                  <div className="icons-shorting" onClick={() => this.handleSort("ScheduledDate")}>
                    <i className="fa fa-long-arrow-up" style={{ cursor: "pointer" }}></i>
                    <i
                      className="fa fa-long-arrow-down"
                      style={{ cursor: "pointer", marginLeft: 3 }}
                    ></i>
                  </div>
                </div>
              </th>

              {/* Status / Work Status */}
              <th>{isModal ? "Work Status" : "Status"}</th>

              {isModal ? (
                <th>Remark</th>
              ) : (
                <>
                  <th>Last Updated by</th>
                  <th className="remark-col">Last Updated Remark</th>
                  {/* <th className="remark-col">Team Member Verified</th> */}
                  <th className="remark-col">Zone Manager Verified</th>
                  <th className="remark-col">Hall Manager Verified</th>
                  {/* Organizer Verified is not a column of its own any more. A
                      Hall Manager verification writes IsVerifyByOrganizer and its
                      stamp as a copy of its own, so the two always read the same */}
                  <th className="text-center">{actionHeader}</th>
                </>
              )}
            </tr>
          </thead>
          <tbody>
            {this.state.HMworkUpdationList?.length > 0 ? (
              visibleRows.map((item, i) =>
                item.isBreak ? (
                  <tr>
                    <td
                      className="text-left"
                    // style={{ color: "white" }}
                    >
                      <strong className="fw-semibold">{item.Hall}</strong>
                    </td>
                    {[...Array(isModal ? 8 : 10)].map((_, idx) => (
                      <td key={idx} className="" style={{ color: "white" }}></td>
                    ))}
                  </tr>
                ) : (
                  <tr>
                    <td className="text-left hall-name">{item.Hall}</td>
                    <td>{item.Zone}</td>
                    <td>{item.Stall}</td>
                    <td>
                      {item.isBreakRow ? (
                        <span>NA</span>
                      ) : (
                        <>
                          <span style={{ fontWeight: 600 }}>{item.ExhRegistrationNo}</span>
                          <br />
                          {item.Exhibitor}
                        </>
                      )}
                    </td>
                    <td>
                      {item.Service || "-"}{" "}
                      {item.Service != 'NA' &&
                        <span
                          style={{ cursor: "pointer", fontSize: "18px", paddingTop: "30px" }}
                          onClick={() =>
                            this.handleManualFormModal(item.Service, item.ExhRegistrationID)
                          }
                        >
                          <i
                            class="bi bi-info-circle"
                            style={{ transition: "color 0.2s" }}
                            onMouseEnter={(e) => (e.target.style.color = "blue")}
                            onMouseLeave={(e) => (e.target.style.color = "")}
                          ></i>
                        </span>
                      }
                    </td>
                    <td className="vendor p-1">
                      {item.isBreakRow ? (
                        <span>NA</span>
                      ) : (
                        <div>
                          <span className="">
                            <i className="fa fa-building-o grid-icon"></i>
                            {item.VendorName}
                            {RoleID != 16 && (
                              <>
                                <a
                                  onClick={() =>
                                    this.navigateToVendorAndScopofwork(
                                      item.VendorUserID,
                                      item.VendorAccountID,
                                      item.WorkOrderID
                                    )
                                  }
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <i className="fa fa-external-link grid-icon mx-1"></i>
                                </a>
                              </>
                            )}
                            <a className="p-0">
                              <span class="material-symbols-outlined grid-icon gi-icon mx-1" title="View Staff"
                                onClick={() =>
                                  this.getVendorStaffList(item.VendorAccountID, item.ServiceID)
                                }>
                                groups
                              </span>
                            </a>
                          </span>
                          <br />
                          <span>
                            <i className="ri-user-3-line grid-icon"></i>{" "}
                            {item.VendorContactPerson}
                          </span>
                          <br />
                          <span className="">
                            <i className="ri-phone-line grid-icon"></i>{" "}
                            {item.VendorContactNo}
                          </span>
                          <br />
                          <span>
                            <i className="ri-mail-line grid-icon"></i> {item.VendorEmail}
                          </span>
                        </div>
                      )}
                    </td>
                    <td>
                      {item.ScheduledDate ? moment(item.ScheduledDate).format("D MMM YYYY") : "-"}{" "}
                      {item.StallPossessionStatusID == 1 ? (
                        <i class="fa fa-file-text grid-icon me-1 fs-6"></i>
                      ) : item.StallPossessionStatusID == 2 ? (
                        <i class="fa fa-check grid-icon me-1 fs-6"></i>
                      ) : item.StallPossessionStatusID == 3 ? (
                        <i style={{ color: "#fb9d12" }} class="fa fa-hourglass-half me-1 fs-6"></i>
                      ) : item.StallPossessionStatusID == 4 ? (
                        <i class="fa fa-exclamation-triangle text-danger me-1 fs-6"></i>
                      ) : (
                        ""
                      )}
                    </td>

                    {isModal ? (
                      <>
                        <td className="text-center">
                          <input
                            type="checkbox"
                            checked={item.WorkStatusID || false}
                            // disabled={isZoneManager || isHallManager}
                            onChange={(e) =>
                              this.handleInput(e, "checkbox", ListIndex != null ? ListIndex : i)
                            }
                          />
                        </td>
                        <td className="remark-col comment-col">
                          <textarea
                            className="form-control"
                            value={item.Remark || ""}
                            style={{ width: "100%", minHeight: "60px" }}
                            rows={3}
                            onChange={(e) =>
                              this.handleInput(e, "input", ListIndex != null ? ListIndex : i)
                            }
                            cols={10}
                          />
                        </td>
                      </>
                    ) : (
                      <>
                        <td>
                          <span
                            // style={{
                            //   color: !item.WorkStatusID ? "" : "",
                            // }}
                            className={item.WorkStatusID ? "status text-aqua" : "status grid-icon"}
                          >
                            {item.WorkStatusID ? "Complete" : "Pending"}
                          </span>
                        </td>
                        <td>
                          {item.LastUpdatedBy && item.LastUpdatedDate ? (
                            <>
                              <span>{item.LastUpdatedBy || "-"}</span> <br />
                              <span className="text-secondary">
                                {" "}
                                {item.LastUpdatedDate != null
                                  ? moment.utc(item.LastUpdatedDate).format("D MMM YYYY HH:mm")
                                  : "-"}
                              </span>
                            </>
                          ) : (
                            <span>-</span>
                          )}
                        </td>
                        <td className="remark-col comment-col">
                          {item.LastUpdatedRemark || "-"}
                          <i
                            className="ri-message-3-line comment-his"
                            onClick={() => this.getWorkUpdationLogList(item.HMWorkupdationID)}
                          ></i>
                        </td>
                        <td>
                          {getApprovalDisplay(
                            this.isFlagOn(item.IsVerifyByZoneManager),
                            () =>
                              this.toggleTaskZoneApproval(
                                item.HMWorkupdationID,
                                item.IsVerifyByZoneManager
                              ),
                            this.canSetZoneApproval(
                              this.isFlagOn(item.WorkStatusID),
                              this.isFlagOn(item.IsVerifyByHallManager),
                              this.isFlagOn(item.IsVerifyByOrganizer)
                            ),
                            this.state.isTeamMember
                              ? "Only Zone Manager or Hall Manager can verify this work."
                              : (this.state.isZoneManager || this.state.isHallManager) && !this.isFlagOn(item.WorkStatusID)
                                ? "Work status must be marked Complete before Zone Manager verification."
                                : (this.state.isZoneManager || this.state.isHallManager) &&
                                  (this.isFlagOn(item.IsVerifyByHallManager) ||
                                    this.isFlagOn(item.IsVerifyByOrganizer))
                                  ? this.zoneLockedMessage(
                                    this.isFlagOn(item.IsVerifyByOrganizer)
                                  )
                                  : "",
                            item.IsVerifyByZoneManagerDateTime
                          )}
                        </td>
                        <td>
                          {getApprovalDisplay(
                            this.isFlagOn(item.IsVerifyByHallManager),
                            () =>
                              this.toggleTaskHallApproval(
                                item.HMWorkupdationID,
                                item.IsVerifyByHallManager
                              ),
                            this.canSetHallApproval(
                              this.isFlagOn(item.IsVerifyByZoneManager),
                              this.isFlagOn(item.IsVerifyByOrganizer)
                            ),
                            this.state.isTeamMember
                              ? "Only Hall Manager can verify this work."
                              : this.state.isHallManager && !this.isFlagOn(item.IsVerifyByZoneManager)
                                ? "Zone Manager verification is required before Hall Manager verification."
                                : this.state.isHallManager &&
                                  this.isFlagOn(item.IsVerifyByOrganizer)
                                  ? this.lockedMessage(true)
                                  : "",
                            item.IsVerifyByHallManagerDateTime
                          )}
                        </td>

                        <td className="text-center">
                          {rowActions
                            .filter((action) => action.isVisible(item))
                            .map((action) => (
                              <i
                                key={action.label}
                                className={action.iconClass}
                                style={{ cursor: "pointer" }}
                                title={action.label}
                                onClick={() => action.onClick(item)}
                              ></i>
                            ))}
                        </td>
                      </>
                    )}
                  </tr>
                )
              )
            ) : (
              <tr>
                <td colSpan={20} className="text-center">
                  Record not found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  }

  navigateToVendorRegistrationAU(userId, accountId, AccountType) {
    this.props.navigate("/vendorAndScopofwork", {
      state: {
        AccountID: accountId,
        UserId: userId,
        update: true,
        AccountType: AccountType,
      },
    });
  }

  handleFilter = (type) => {
    this.setState((prev) => {
      const filtered = this.applyCountFilter(prev.HMworkUpdationListForFilter, type);

      return {
        HMworkUpdationList: JSON.parse(JSON.stringify(filtered)),
        countFilter: type,
      };
    });
  };

  openModal(ServiceName) {
    if (ServiceName === "Fascia") {
      return <FasciaForm />;
    } else if ((ServiceName || "").trim() === "Exhibitor Paid Badges") {
      return <ExhibitorBadge />;
    } else if ((ServiceName || "").trim() === "exhibitorDetails") {
      return <ExhibitorDetails />;
    } else if ((ServiceName || "").trim() === "Visa Application  ") {
      return <VisaApplication />;
    } else if ((ServiceName || "").trim() === "edirectoryList") {
      return <EDirectoryList />;
    } else if ((ServiceName || "").trim() === "Keywords") {
      return <KeywordsInformation />;
    } else if ((ServiceName || "").trim() === "Stall Design") {
      return <StallDesign />;
    } else if ((ServiceName || "").trim() === "Furniture") {
      return <AdditionalFurniture />;
    } else if ((ServiceName || "").trim() === "Stall Possession") {
      return <StallPossession />;
    } else if ((ServiceName || "").trim() === "Power") {
      return <PowerConnection />;
    } else if ((ServiceName || "").trim() === "Freight Forwarders") {
      return <FreightForward />;
    } else if ((ServiceName || "").trim() === "Water") {
      return <Water />;
    } else if ((ServiceName || "").trim() === "Air") {
      return <AirConnectionApplication />;
    } else if ((ServiceName || "").trim() === "Car Passes") {
      return <CarPassesApplication />;
    } else if (ServiceName === "Liquor License") {
      return <LiquareLicense />;
    } else if ((ServiceName || "").trim() === "Lead Retrieval") {
      return <LeadRetrievalConnectionApplication />;
    } else if ((ServiceName || "").trim() === "Meeting Room") {
      return <MeetingRoomRequestForm />;
    } else if ((ServiceName || "").trim() === "delegateMeeting") {
      return <DelegateMeeting />;
    } else if ((ServiceName || "").trim() === "visitorMeetingApplication") {
      return <VisitorMeetingApplication />;
    } else if ((ServiceName || "").trim() === "Internet Connection") {
      return <InternetConnection />;
    } else if ((ServiceName || "").trim() === "Housekeeping") {
      return <HousekeepingConnection />;
    } else if ((ServiceName || "").trim() === "Security") {
      return <SecurityApplication />;
    } else if ((ServiceName || "").trim() === "Catering") {
      return <CateringServices />;
    } else if ((ServiceName || "").trim() === "Host and Hostess") {
      return <HostHostessRequirements />;
    } else if ((ServiceName || "").trim() === "Branding Opportunity  ") {
      return <BrandingOpportunityAndAdvertisement />;
    } else if ((ServiceName || "").trim() === "AV Equipments ") {
      return <RentalAudioAndVideoEquipment />;
    } else if ((ServiceName || "").trim() === "Contractor Badge  ") {
      return <ExhibitorContractorBadgeApplication />;
    } else if ((ServiceName || "").trim() === "plantAndBeautification") {
      return <PlantAndBeautification />;
    } else {
      return null; // or <NotFound />
    }
  }

  handleManualFormModal = (serviceName, ExhRegistrationID) => {
    sessionStorage.setItem("ExhRegistrationIDSS", ExhRegistrationID);
    this.setState({
      isManualFormModalOpen: true,
      selectedServiceName: serviceName,
    });
  };

  render() {
    const {
      isLoading,
      isUpdateModalOpen,
      hallId,
      hallList,
      zoneId,
      zoneList,
      serviceId,
      serviceList,
      ExhibitorName,
      ExhRegNo,
      VendorName,
      OtherAreaCountList,
      HMworkUpdationList,
      HMworkUpdationListForFilter,
      ListIndex,
      StatusList,
      isHallManagerModalOpen,
      HallManagerList,
      RoleID,
      isCommentPop,
      commentList,
      isOpenConfirmationModal
    } = this.state;
    const { isHideSection } = this.props;
    // This screen serves every role that can land on it - Hall Manager, Zone
    // Manager, and Admin/Organizer (isAdmin above). The header (and with it the
    // notification bell) was gated to Hall Manager only, so everyone else's
    // mail arrived correctly but their bell never had anywhere to render
    const showAppHeader = RoleID == 16 || RoleID == 25 || RoleID == 2 || RoleID == 6;
    return (
      <>
        {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {showAppHeader && <HeaderWithLogo />}
        {/* <ExhibitorDrawer /> */}
        <>
          {/* <AdminDrawer /> */}
          {/*app-content open*/}
          <div
            className={
              isHideSection
                ? ""
                : showAppHeader
                  ? "with-dr-container"
                  : "with-dr-container admin-top-space"
            }
            style={{ marginLeft: 0 }}
          >
            <main id="main" class={showAppHeader ? "px-1" : "px-1"}>
              {this.state.showVideoModal && (
                <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={() => this.setState({ showVideoModal: false })}>
                  <div className="modal-dialog modal-lg modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Work Updation</h5>
                        <button type="button" className="btn-close" onClick={() => this.setState({ showVideoModal: false })}></button>
                      </div>
                      <div className="modal-body">
                        <video controls autoPlay style={{ width: '100%' }}>
                          <source src="/assets/WorkUpdation.mp4" type="video/mp4" />
                        </video>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div
                class={`pagetitle d-flex flex-column flex-md-row align-items-md-center justify-content-between border-bottom py-2 ${showAppHeader ? "admin-top-space" : ""
                  }`}
              >
                {/* <nav>
                  <ol class="breadcrumb mb-0">
                    <li
                      class="breadcrumb-item active fw-bolder"
                      style={{ background: "none" }}
                    >
                      Hall Manager Work Updation
                    </li>
                  </ol>
                </nav> */}
                <div className="row m-0">
                  <div className="ms-auto d-flex flex-column flex-md-row align-items-start align-items-md-center gap-2 mx-2 w-100">

                    {/* Breadcrumb / Info text */}
                    <nav className="w-100 w-md-auto">
                      <ol className="breadcrumb mb-0 text-wrap">
                        <li className="high-light-text">
                          Work updates are due at 6:00 PM.&nbsp;
                          <a
                            onClick={() => this.setState({ isUpdateModalOpen: true })}
                            style={{ cursor: "pointer" }}
                            className="smooth-blink text-aqua"
                          >
                            Click here to update details.
                          </a>
                        </li>
                      </ol>
                    </nav>

                    {/* Status buttons */}
                    <div className="d-flex flex-wrap flex-md-nowrap gap-2 status-scroll">
                      {/* <span 
                      onClick={() => this.setState({ showVideoModal: true })} 
                      style={{ cursor: 'pointer', color: '#3dbca7', fontSize: '16px', whiteSpace: 'nowrap' }}
                    >
                      <i className="bi bi-play-circle-fill me-2"></i>User Manual
                    </span> */}

                      {/* Total */}
                      <div
                        className="p-1 rounded-1 status-btn"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleFilter("all")}
                      >
                        <i className="fa fa-bar-chart fs-6 me-1"></i>
                        <span>Total:</span>
                        <strong className="ms-1">
                          {HMworkUpdationListForFilter.filter((item) => !item.isBreak).length}
                        </strong>
                      </div>

                      {/* Completed */}
                      <div
                        className="p-1 rounded-1 status-btn"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleFilter("completed")}
                      >
                        <i className="fa fa-check me-1 fs-6"></i>
                        <span>Completed:</span>
                        <strong className="ms-1">
                          {
                            HMworkUpdationListForFilter.filter(
                              (item) => item.WorkStatusID == 1 && !item.isBreak
                            ).length
                          }
                        </strong>
                      </div>

                      {/* Pending */}
                      <div
                        className="p-1 rounded-1 status-btn"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleFilter("pending")}
                      >
                        <i className="fa fa-hourglass-half me-1 fs-6"></i>
                        <span>Pending:</span>
                        <strong className="ms-1">
                          {
                            HMworkUpdationListForFilter.filter(
                              (item) => item.WorkStatusID != 1 && !item.isBreak
                            ).length
                          }
                        </strong>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              <section class="section" style={{ padding: 0 }}>
                <div class="row m-0">
                  <div class="container-fluid pt-1 pb-0 px-2">
                    <div className="d-lg-flex align-items-end w-100">
                      <div className="flex-fill me-2 mb-2">
                        <label className="ms-1">Hall</label>
                        <select
                          className="form-control"
                          id="roledb"
                          value={hallId}
                          onChange={(e) =>
                            this.setState({ hallId: e.target.value }, () => {
                              if (e.target.value != "") {
                                this.getFillList(
                                  HallZoneActionId,
                                  this.state.exhibitionID,
                                  e.target.value,
                                  "",
                                  "",
                                  "",
                                  false
                                );
                              } else {
                                this.setState({ zoneList: [] });
                              }
                            })
                          }
                        >
                          <option value={""}>Select</option>
                          {hallList.length > 0 &&
                            hallList.map((data) => (
                              <option key={data.HallId} value={data.HallId}>
                                {data.HallName}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div className="flex-fill me-2 mb-2">
                        <label className="ms-1">Zone</label>
                        <select
                          className="form-control"
                          id="roledb"
                          value={zoneId}
                          onChange={(e) => this.setState({ zoneId: e.target.value })}
                        >
                          <option value={""}>Select</option>
                          {zoneList.length > 0 &&
                            zoneList.map((data) => (
                              <option key={data.HallZoneMappingID} value={data.HallZoneMappingID}>
                                {data.Zone}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div className="flex-fill me-2 mb-2">
                        <label className="ms-1">Exhibitor Reg. No.</label>
                        <input
                          type="text"
                          className="form-control"
                          value={ExhRegNo}
                          onChange={(e) => this.setState({ ExhRegNo: e.target.value })}
                          maxLength={100}
                        />
                      </div>

                      <div className="flex-fill me-2 mb-2">
                        <label className="ms-1">Exhibitor</label>
                        <input
                          type="text"
                          className="form-control"
                          value={ExhibitorName}
                          onChange={(e) => this.setState({ ExhibitorName: e.target.value })}
                          maxLength={100}
                        />
                      </div>

                      <div className="flex-fill me-2 mb-2">
                        <label className="ms-1">Services</label>
                        <select
                          className="form-control"
                          id="roledb"
                          value={serviceId}
                          onChange={(e) => this.setState({ serviceId: e.target.value })}
                        >
                          <option value={""}>Select</option>
                          {serviceList.length > 0 &&
                            serviceList.map((data) => (
                              <option key={data.ServiceID} value={data.ServiceID}>
                                {data.Name}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div className="flex-fill me-2 mb-2">
                        <label className="ms-1 w-100">Service Partner</label>
                        <input
                          type="text"
                          className="form-control"
                          value={VendorName}
                          onChange={(e) => this.setState({ VendorName: e.target.value })}
                          maxLength={100}
                        />
                      </div>

                      <div className="me-2 mb-2 d-flex gap-2">
                        <button
                          className="btn btn-aqua"
                          onClick={() => this.getHallManagerWorkUpdationList()}
                        >
                          Search
                        </button>
                        <button
                          className="btn btn-gray"
                          onClick={() => this.handleClear()}
                        >
                          Clear
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="row m-0">
                    <div class="d-block d-lg-flex justify-content-between align-items-center px-0 mb-0">
                      <div class="d-flex flex-wrap gap-1 w-100 mb-1 mb-lg-0">
                        {OtherAreaCountList.length > 0 ? (
                          OtherAreaCountList.map((item, index) => {
                            return (
                              <div
                                key={index}
                                className="d-flex align-items-center px-1 py-1 border rounded small"
                                style={{
                                  backgroundColor: "#f4f7ff",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  this.setState(
                                    {
                                      ExhibitionOtherAreaID: item.ExhibitionOtherAreaID,
                                    },
                                    () => this.getHallManagerWorkUpdationList()
                                  )
                                }
                              >
                                <span style={{ color: item.TextColour }}>
                                  {item.ExhibitionOtherArea}:
                                </span>
                                <strong className="ms-1 grid-icon">
                                  {item.CompletedCount || 0}/{item.TotalCount}
                                </strong>
                              </div>
                            );
                          })
                        ) : (
                          <div className="text-left"></div>
                        )}
                      </div>
                      <div className="d-flex justify-content-lg-end justify-content-start w-100 w-lg-auto p-0 mb-1">
                        <div className="d-flex align-items-center status-scroll">
                          <div
                            className="p-1 rounded-1 status-btn mx-1"
                            onClick={() =>
                              this.setState({ PossessionStatusID: 1 }, () =>
                                this.getHallManagerWorkUpdationList()
                              )
                            }
                          >
                            <i class="fa fa-file-text me-1 fs-6"></i>
                            <span className="">NDC Issued:</span>
                            <strong className="ms-1" style={{ fontSize: 15 }}>
                              {StatusList.length > 0 && StatusList[0]["StatusCount"]}
                            </strong>
                          </div>
                          {/* Total Taken */}
                          <div
                            className="p-1 rounded-1 status-btn mx-1"
                            onClick={() =>
                              this.setState({ PossessionStatusID: 2 }, () =>
                                this.getHallManagerWorkUpdationList()
                              )
                            }
                          >
                            <i class="fa fa-check  me-1 fs-6"></i>
                            <span className="">Stall Possession:</span>
                            <strong className="ms-1 " style={{ fontSize: 15 }}>
                              {StatusList.length > 0 && StatusList[1]["StatusCount"]}
                            </strong>
                          </div>
                          {/* Total Pending */}
                          <div
                            className="p-1 rounded-1 status-btn mx-1"
                            onClick={() =>
                              this.setState({ PossessionStatusID: 3 }, () =>
                                this.getHallManagerWorkUpdationList()
                              )
                            }
                          >
                            <i class="fa fa-hourglass-half me-1 fs-6"></i>
                            <span className="">Possession Pending:</span>
                            <strong className="ms-1">
                              {StatusList.length > 0 && StatusList[2]["StatusCount"]}
                            </strong>
                          </div>
                          {/* Total Possession Due */}
                          <div
                            className="p-1 rounded-1 status-btn mx-1"
                            onClick={() =>
                              this.setState({ PossessionStatusID: 4 }, () =>
                                this.getHallManagerWorkUpdationList()
                              )
                            }
                          >
                            <i class="fa fa-exclamation-triangle me-1 fs-6"></i>
                            <span className="">No Show:</span>
                            <strong className="ms-1" style={{ fontSize: 15 }}>
                              {StatusList.length > 0 && StatusList[3]["StatusCount"]}
                            </strong>
                          </div>
                        </div>
                      </div>
                    </div>

                    {this.renderWorkUpdationList(false)}
                  </div>

                  {/* <!-- Hall Script --> */}
                </div>
              </section>
            </main>
          </div>

          <Modal
            isOpen={isUpdateModalOpen}
            onRequestClose={() => this.setState({ isUpdateModalOpen: false, ListIndex: null })}
          >
            <div className="modal-dialog modal-almost-fullscreen">
              <div className="modal-content">
                <div className="modal-header py-3 text-white flex-wrap gap-2 position-relative">
                  <h6 className="mb-0 d-flex flex-wrap align-items-center gap-2 pe-4">
                    <span>Update Details</span>
                    <span className="status-badge text-aqua text-nowrap">03 Dec 2026 - 06:00 PM</span>
                  </h6>
                  <div className="ms-auto d-flex flex-wrap align-items-center gap-2 pe-4">
                    <>
                      <div
                        className="p-1 rounded-1 status-btn"
                        onClick={() => this.handleFilter("all")}
                      >
                        <i className="fa fa-bar-chart fs-6"></i>
                        <span>Total:</span>
                        <strong className="ms-1">
                          {HMworkUpdationListForFilter.filter((item) => !item.isBreak).length}
                        </strong>
                      </div>

                      <div
                        className="p-1 rounded-1 status-btn"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleFilter("completed")}
                      >
                        <i className="fa fa-check me-1 fs-6"></i>
                        <span>Completed:</span>
                        <strong className="ms-1">
                          {
                            HMworkUpdationListForFilter.filter(
                              (item) => item.WorkStatusID == 1 && !item.isBreak
                            ).length
                          }
                        </strong>
                      </div>

                      <div
                        className="p-1 rounded-1 status-btn"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleFilter("pending")}
                      >
                        <i className="fa fa-hourglass-half me-1 fs-6"></i>
                        <span>Pending:</span>
                        <strong className="ms-1">
                          {
                            HMworkUpdationListForFilter.filter(
                              (item) => item.WorkStatusID != 1 && !item.isBreak
                            ).length
                          }
                        </strong>
                      </div>
                    </>

                    {/* Close Button */}
                    <button
                      type="button"
                      className="btn-close position-absolute"
                      data-bs-dismiss="modal"
                      onClick={() =>
                        this.setState({ isUpdateModalOpen: false, ExhRegNo: "" }, () =>
                          this.getHallManagerWorkUpdationList()
                        )
                      }
                      style={{ right: "15px", top: "15px", fontSize: "18px !important" }}
                    />
                  </div>
                </div>

                <div class="modal-body p-1">
                  <section class="section" style={{ padding: 0 }}>
                    <div class="row m-0">
                      <div className="d-lg-flex align-items-end w-100">

                        {/* Hall */}
                        <div className="flex-fill me-2 mb-2">
                          <label className="ms-1">Hall</label>
                          <select
                            className="form-control"
                            value={hallId}
                            onChange={(e) =>
                              this.setState({ hallId: e.target.value }, () => {
                                if (e.target.value !== "") {
                                  this.getFillList(
                                    HallZoneActionId,
                                    this.state.exhibitionID,
                                    e.target.value,
                                    "",
                                    "",
                                    "",
                                    false
                                  );
                                } else {
                                  this.setState({ zoneList: [] });
                                }
                              })
                            }
                          >
                            <option value="">Select</option>
                            {hallList.map((data) => (
                              <option key={data.HallId} value={data.HallId}>
                                {data.HallName}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* Zone */}
                        <div className="flex-fill me-2 mb-2">
                          <label className="ms-1">Zone</label>
                          <select
                            className="form-control"
                            value={zoneId}
                            onChange={(e) => this.setState({ zoneId: e.target.value })}
                          >
                            <option value="">Select</option>
                            {zoneList.map((data) => (
                              <option key={data.HallZoneMappingID} value={data.HallZoneMappingID}>
                                {data.Zone}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* Exhibitor Reg. No. */}
                        <div className="flex-fill me-2 mb-2">
                          <label className="ms-1">Exhibitor Reg. No.</label>
                          <input
                            type="text"
                            className="form-control"
                            value={ExhRegNo}
                            onChange={(e) => this.setState({ ExhRegNo: e.target.value })}
                            maxLength={100}
                          />
                        </div>

                        {/* Exhibitor */}
                        <div className="flex-fill me-2 mb-2">
                          <label className="ms-1">Exhibitor</label>
                          <input
                            type="text"
                            className="form-control"
                            value={ExhibitorName}
                            onChange={(e) => this.setState({ ExhibitorName: e.target.value })}
                            maxLength={100}
                          />
                        </div>

                        {/* Services */}
                        <div className="flex-fill me-2 mb-2">
                          <label className="ms-1">Services</label>
                          <select
                            className="form-control"
                            value={serviceId}
                            onChange={(e) => this.setState({ serviceId: e.target.value })}
                          >
                            <option value="">Select</option>
                            {serviceList.map((data) => (
                              <option key={data.ServiceID} value={data.ServiceID}>
                                {data.Name}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* Service Partner (reduced width) */}
                        <div className="flex-fill me-2 mb-2">
                          <label className="ms-1 w-100">Partner</label>
                          <input
                            type="text"
                            className="form-control"
                            value={VendorName}
                            onChange={(e) => this.setState({ VendorName: e.target.value })}
                            maxLength={100}
                          />
                        </div>

                        {/* Buttons */}
                        <div className="me-2 mb-2 d-flex gap-2">
                          <button
                            className="btn btn-aqua"
                            onClick={() => this.getHallManagerWorkUpdationList()}
                          >
                            Search
                          </button>
                          <button
                            className="btn btn-gray"
                            onClick={() => this.handleClear()}
                          >
                            Clear
                          </button>
                        </div>

                      </div>


                      <div class="row m-1">
                        {ListIndex == null && (
                          <div class="d-flex justify-content-between align-items-center gap-3 px-0 mb-2">
                            <div class="d-flex flex-wrap gap-3">
                              {OtherAreaCountList.length > 0 ? (
                                OtherAreaCountList.map((item, index) => {
                                  return (
                                    <div
                                      key={index}
                                      className="d-flex align-items-center px-1 py-1 border rounded small"
                                      style={{
                                        backgroundColor: "#f4f7ff",
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        this.setState(
                                          {
                                            ExhibitionOtherAreaID: item.ExhibitionOtherAreaID,
                                          },
                                          () => this.getHallManagerWorkUpdationList()
                                        )
                                      }
                                    >
                                      <span style={{ color: item.TextColour }}>
                                        {item.ExhibitionOtherArea}:
                                      </span>
                                      <strong className="ms-1 grid-icon">
                                        {item.CompletedCount || 0}/{item.TotalCount}
                                      </strong>
                                    </div>
                                  );
                                })
                              ) : (
                                <div className="text-left"></div>
                              )}
                            </div>
                          </div>
                        )}
                        {this.renderWorkUpdationList(true)}
                      </div>

                      {/* <!-- Hall Script --> */}
                    </div>
                  </section>
                </div>

                <div class="modal-footer p-1">
                  <div class="form-group text-right mod-fot">
                    <button
                      type="button"
                      class="btn btn-aqua"
                      // onClick={(e) => this.updateHallManagerWorkUpdation()}
                      onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to Submit?`, buttonName: "Submit", action: 0 }, popArg: [] })}
                    >
                      Update
                    </button>
                    <button
                      type="button"
                      class="btn btn-gray"
                      data-dismiss="modal"
                      style={{ marginLeft: "5px" }}
                      onClick={() =>
                        this.setState({ isUpdateModalOpen: false, ExhRegNo: "", ExhibitionOtherAreaID: null }, () =>
                          this.getHallManagerWorkUpdationList()
                        )
                      }
                    >
                      No
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Modal>

          <Modal
            isOpen={isHallManagerModalOpen}
            onRequestClose={() => this.setState({ isHallManagerModalOpen: false })}
          >
            <div className="modal-dialog modal-almost-fullscreen">
              <div className="modal-content">
                <div class="modal-header p-2">
                  <h6 class="modal-title"> Staff Details
                  </h6>
                  {/* <div className="ms-auto d-flex align-items-center gap-3">
                    <button
                      type="button"
                      className="btn-close ms-2"
                      data-bs-dismiss="modal"
                      onClick={() => this.setState({ isHallManagerModalOpen: false })}
                      style={{ fontSize: "18px !important" }}
                    />
                  </div> */}
                </div>

                <div className="modal-body">
                  {HallManagerList.length > 0 ? (
                    <div style={{ maxHeight: 500, overflowY: "auto", overflowX: "hidden" }}>
                      {HallManagerList.map((data, index) => (
                        <div key={index} className="mb-4">
                          {/* Staff Cards */}
                          <div className="row g-3">
                            {data.Staff && data.Staff.length > 0 ? (
                              data.Staff.map((item, idx) => {
                                // 🔹 Dynamic badge color mapping
                                let badgeColor = "#6c757d"; // default gray
                                switch (item.TypeName) {
                                  case "Pre-Setup":
                                    badgeColor = "#0d6efd"; // blue
                                    break;
                                  case "Dismantling":
                                    badgeColor = "#dc3545"; // red
                                    break;
                                  case "All":
                                    badgeColor = "#198754"; // green
                                    break;
                                  case "EventDays":
                                    badgeColor = "#ffc107"; // yellow
                                    break;
                                  default:
                                    badgeColor = "#6610f2"; // fallback gray
                                }

                                return (
                                  <div key={idx} className="col-md-3 col-sm-6 position-relative">
                                    <div
                                      className="card h-100 m-0 shadow-sm border rounded-3 position-relative"
                                      style={{
                                        borderColor: "#343a40",
                                        borderWidth: "2px",
                                      }}
                                    >
                                      {/* Event Type Badge */}
                                      <span
                                        className="badge position-absolute top-0 end-0 m-2"
                                        style={{
                                          backgroundColor: badgeColor,
                                          color: "white",
                                          fontSize: "0.75rem",
                                          borderRadius: "0.5rem",
                                          padding: "0.35rem 0.6rem",
                                          zIndex: 10,
                                        }}
                                      >
                                        {item.TypeName}
                                      </span>

                                      <div className="card-body mt-3 p-1 d-flex align-items-center">
                                        <div className="me-3">
                                          <div
                                            className="bg-light rounded-circle d-flex align-items-center justify-content-center"
                                            style={{ width: 50, height: 50 }}
                                          >
                                            <i className="ri-user-3-line fs-4 grid-icon" />
                                          </div>
                                        </div>
                                        <div>
                                          <h6 className="mb-1 fw-bold">{item.PersonName}</h6>
                                          <p className="mb-0 text-muted small">
                                            <i className="ri-phone-line text-danger me-1" />
                                            {item.MobileNumber}
                                          </p>
                                          <p className="mb-0 text-muted small">
                                            <i className="ri-mail-line text-info me-1" />
                                            {item.EmailID}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })
                            ) : (
                              <p className="text-muted small">No staff found for this service.</p>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div>Record not found</div>
                  )}
                </div>

                <div class="modal-footer p-1">
                  <div class="form-group text-right mod-fot">
                    <button
                      type="button"
                      class="btn btn-gray"
                      data-dismiss="modal"
                      style={{ marginLeft: "5px" }}
                      onClick={() =>
                        this.setState({
                          isHallManagerModalOpen: false,
                          ListIndex: null,
                        })
                      }
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Modal>

          <Modal
            isOpen={isCommentPop}
            onRequestClose={() => this.setState({ isCommentPop: false })}
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div class="modal-header py-3 text-white">
                  <h6 className="mb-0">Remark</h6>
                </div>

                <div className="modal-body" style={{ background: "#f9fafb" }}>
                  {/* Chat Section */}
                  {commentList.length > 0 ? (
                    commentList.map((item, index) => (
                      <div
                        key={index}
                        className="chat-box"
                        style={{
                          maxHeight: 400,
                          overflowY: "auto",
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                        }}
                      >
                        {item.LastUpdatedBy !=
                          JSON.parse(sessionStorage.getItem("loginDataSS")).UserID ? (
                          // Incoming message
                          <div
                            className="message incoming"
                            style={{ alignSelf: "flex-start", maxWidth: "80%" }}
                          >
                            <div
                              className="meta"
                              style={{
                                fontSize: 12,
                                color: "#6b7280",
                                marginBottom: 4,
                              }}
                            >
                              {item.PersonName}  {item.Designation ? `(${item.Designation})` : ""} •{" "}
                              {moment.utc(item.LastUpdatedDate).format("DD/MM/YYYY, hh:mm A")}
                            </div>

                            <div
                              className="bubble"
                              style={{
                                // background:
                                //   index === commentList.length - 1 ? "#777777" : undefined,
                                // color:
                                //   index === commentList.length - 1 ? "#ffff" : undefined,
                                borderRadius: "12px 12px 4px 12px",
                                padding: "8px 16px",
                                fontSize: 14,
                                border: "1px solid #e5e7eb",
                              }}
                            >
                              {item.Remark}
                            </div>
                          </div>
                        ) : (
                          // Outgoing message
                          <div
                            className="message outgoing"
                            style={{
                              alignSelf: "flex-end",
                              maxWidth: "80%",
                              textAlign: "right",
                            }}
                          >
                            <div
                              className="meta"
                              style={{
                                fontSize: 12,
                                color: "#6b7280",
                                marginBottom: 4,
                              }}
                            >
                              You • {moment.utc(item.LastUpdatedDate).format("DD/MM/YYYY, hh:mm A")}
                            </div>

                            <div
                              className="bubble"
                              style={{
                                borderRadius: "12px 12px 4px 12px",
                                padding: "8px 16px",
                                fontSize: 14,
                                border: "1px solid #e5e7eb",
                              }}
                            >
                              {item.Remark}
                            </div>
                          </div>
                        )}
                      </div>
                    ))
                  ) : (
                    <div className="text-left">Record not found</div>
                  )}
                </div>

                <div class="modal-footer p-1">
                  <div class="form-group text-right mod-fot">
                    <button
                      type="button"
                      class="btn btn-gray"
                      data-dismiss="modal"
                      style={{ marginLeft: "5px" }}
                      onClick={() => this.setState({ isCommentPop: false, ListIndex: null })}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Modal>

          <Modal
            isOpen={this.state.isManualFormModalOpen}
            onRequestClose={() => this.setState({ isManualFormModalOpen: false })}
            shouldCloseOnEsc={true}
            shouldCloseOnOverlayClick={true}
            ariaHideApp={false}
          >
            <div className="modal-dialog modal-xl">
              <div className="modal-content">
                <div className="modal-header p-2">
                  <h6 className="modal-title">Manual Form</h6>
                  {/* <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={() => this.setState({ isManualFormModalOpen: false })}
                  /> */}
                </div>

                <div className="modal-body">{this.openModal(this.state.selectedServiceName)}</div>


                <div className="modal-footer py-1">
                  <button
                    className="btn btn-gray"
                    onClick={() => this.setState({ isManualFormModalOpen: false })}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        </>
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    fill_action,
    getHallManagerWorkUpdatationList_action,
    updateHallManagerWorkUpdatationList_action,
    getWorkUpdationLogList_action,
    getVendorStaffList_action,
  })(WorkUpdation)
);
